import React from 'react';
import { Table, Icon } from 'antd';
import { WebsiteIndexEntry, UpdateWebsiteIndexEntrySettingsParams } from '../../../deepAnalysis/websiteIndexEntry/types';


const { Column } = Table;

type TableRecord = {
    index: number;
    competitor: string;
};

type Props = {
    selectedWebsite: WebsiteIndexEntry;
    remainingCompetitors: string[];
    isRemovingCompetitor: boolean;
    onCompetitorsChange: (args: UpdateWebsiteIndexEntrySettingsParams, action: 'add' | 'remove') => void;
};

export default function CompetitorsTable({ selectedWebsite, remainingCompetitors, isRemovingCompetitor, onCompetitorsChange }: Props) {
    const handleRemoveCompetitor = (removedCompetitor: string) => {
        const updatedCompetitors = selectedWebsite.settings.competitors.filter((competitor) => competitor !== removedCompetitor);
        const action = "remove";
        onCompetitorsChange({ guid: selectedWebsite.guid, competitors: updatedCompetitors }, action);
    };

    const competitorsTableData = selectedWebsite.settings.competitors.map((competitor, index) => ({
        key: competitor,
        index: index + 1,
        competitor: competitor,
    }));

    return (
        <Table
            className="custom-scrollbar"
            dataSource={competitorsTableData}
            showHeader={false}
            pagination={false}
        >
            <Column
                key="index"
                width="5%"
                dataIndex="index"
            />
            <Column
                key="competitor"
                dataIndex="competitor"
                render={(text, record: TableRecord, index) => (
                    <a
                        href={record.competitor}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {record.competitor}
                    </a>
                )}
            />
            <Column
                key="removeCompetitorAction"
                align="right"
                render={(text, record: TableRecord, index) => (
                    <span
                        className={`remove-item ${isRemovingCompetitor && !remainingCompetitors.includes(record.competitor) ? 'in-progress' : ''}`}
                        onClick={() => handleRemoveCompetitor(record.competitor)}
                    >
                        {isRemovingCompetitor && !remainingCompetitors.includes(record.competitor) ? <Icon type="loading" /> : <Icon type="delete" />}
                    </span>
                )}
            />
        </Table>
    );
}
